import axios from "axios";

class ContentService
{
    constructor()
    {
        this.baseUrl = `${process.env.REACT_APP_BASE_ENDPOINT}/contents/okaf`;
    }

    async getAllContentsByCategoryAndNumber(categoryId, numberOfContents)
    {
        const url = `${this.baseUrl}/${categoryId}/${numberOfContents}`
        console.log(url)
        return await axios
            .get(url)
            .then((resp) => resp.data)
            .catch((err) => console.log(err));
    }

    async getOneContentWithCategory(uri)
    {
        const url = `${this.baseUrl}/${uri}`
        console.log(url)
        return await axios
            .get(url)
            .then((resp) =>
            {
                console.log(resp.data)
                return resp.data
            })
            .catch((err) => console.log(err));
    }

}

export default ContentService;